module.exports = __webpack_public_path__ + "static/media/Leccion-7-30-Restaurados.4883a2db.pdf";